<template>

<b-container id="app">
  <b-row>
    <b-col></b-col>
    <b-col cols="6"><b-button class="btn-circle" @click="addBeer"><p class="big-beer">🍺</p></b-button></b-col>
    <b-col></b-col>
  </b-row>
  <b-row>
    <b-col cols="2" v-for="n in beers"><p class="small-beer">🍺</p></b-col>
  </b-row>
  <b-row>
    <b-col></b-col>
    <b-col cols="4"><b-button @click="resetBeers">RESET</b-button></b-col>
    <b-col></b-col>
  </b-row>
</b-container>

</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      beers: 0,
    }
  },
  beforeMount() {
    const beerStorage = Number(localStorage.getItem('beerAmount'));
    if (beerStorage && beerStorage > 0) {
      this.beers = beerStorage;
    }
    console.log(this.beers);
  },
  methods: {
    addBeer() {
      this.beers += 1;
      localStorage.setItem('beerAmount', this.beers);
    },
    resetBeers() {
      this.beers = 0;
      localStorage.setItem('beerAmount', this.beers);
    }
  }
}
</script>

<style>
html, body {
  background-color: #212121;
}

html {
  width: 100%;
  height: 100%;

}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}

.row {
  margin-top: 5em;
}

p.big-beer {
  /* margin: 10px 0 0 10px; */
  text-align: center;
  font-size: 7em;
}
p.small-beer {
  text-align: center;
  font-size: 2em;
}

.btn-circle {
    width: 10em;
    height: 10em;
    border-radius: 10em;
    text-align: center;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue